'use client';

import React from 'react';

import { IconSortAscending } from '@tabler/icons-react';

import { type SORT_DIRECTION } from '@/utils/enums';

import { cn } from '@/_helpers/cn';

interface ITableHeaderBase {
  children?: React.ReactNode;
}

interface ITableHeader extends ITableHeaderBase {
  sortCallback?: never;
  sortDirection?: never;
}

interface ISortableTableHeader extends ITableHeaderBase {
  sortCallback: () => void;
  sortDirection: SORT_DIRECTION.ASC | SORT_DIRECTION.DESC;
}

export const TableHeader = ({ children, sortCallback, sortDirection }: ITableHeader | ISortableTableHeader) => (
  <th>
    <div
      className={cn('flex max-w-[14ch] items-center whitespace-nowrap', sortCallback ? 'cursor-pointer' : null)}
      onClick={sortCallback}
    >
      {children}
      {sortDirection ? (
        <IconSortAscending
          className={`mx-2 size-3 transition duration-500 ease-in-out ${
            sortDirection === 'desc' ? 'rotate-180' : 'rotate-0'
          }`}
        />
      ) : null}
    </div>
  </th>
);

TableHeader.displayName = 'TableHeader';
